import { render, staticRenderFns } from "./NuevoColaborador.vue?vue&type=template&id=8f9fd2f4&"
import script from "./NuevoColaborador.vue?vue&type=script&lang=js&"
export * from "./NuevoColaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports